export default class BucketNotFoundError extends Error {}
